module.exports = __webpack_public_path__ + "img/none.dc79ea7e.png";